import { createAction } from "@ngrx/store";
import { BoardStructure } from "./models/board-structure.model";

export const boardStructureReset = createAction(
    '[Shared] board structure reset',
    (structure: BoardStructure) => ({ structure })
)

export const boardStructureModified = createAction(
    '[Shared] board structure modified',
    (structure: BoardStructure) => ({ structure })
)

